/* Piko smooth scroll — lightweight, performance-safe (NO motion blur).

   The previous version hijacked the mouse wheel and applied an SVG
   Gaussian-blur filter to #MainContent every animation frame. That forced a
   full-page repaint on every frame and made scrolling extremely laggy/slow.
   Both have been removed. This now only enables cheap, GPU-friendly native
   smooth scrolling for in-page anchor jumps — zero per-frame work. */
(function () {
  // Clean up anything the old version may have left in the DOM.
  try {
    var main = document.getElementById('MainContent');
    if (main) main.style.filter = '';
    var gb = document.getElementById('pkScrollBlur');
    if (gb) {
      var svg = gb.closest ? gb.closest('svg') : (gb.ownerSVGElement || null);
      if (svg && svg.parentNode) svg.parentNode.removeChild(svg);
    }
  } catch (e) {}

  if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // Native smooth scrolling for anchor links only. This is compositor-driven
  // and does not repaint the page, so it has no measurable performance cost.
  try { document.documentElement.style.scrollBehavior = 'smooth'; } catch (e) {}
})();
